import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="text-5xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-2xl text-gray-600 mb-4">Page Not Found</h2>
      <p className="text-gray-500 mb-6">
        Sorry, the page you're looking for does not exist.
      </p>
      <Link to="/" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-200">
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
